import misRutas from 'vue-routes-generator'
import CobrosMainComponent from './App'
import CobrosListadoComponent from './components/cobros/index'
import ComisionesComponent from './components/comisiones/index'
export default {
	install: Vue => {
		misRutas.route('/main').child('cobros', {
			name: 'Gestión de cobros y recibos',
			component: CobrosMainComponent
		})

		misRutas.route('/main').child('cobros').child('cobros', {
			name: 'Gestión de cobros',
			component: CobrosListadoComponent
		})

		misRutas.route('/main').child('cobros').child('comisiones', {
			name: 'Gestión de comisiones',
			component: ComisionesComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/facturacion-cobros/vue/index.js